export default function LanguageSwitcher() {
  return null;
}
